<script setup lang="ts">
import DashboardLayout from '@/onenetwork/layouts/DashboardLayout.vue'
import { Form } from '@primevue/forms'
import { useRoute, useRouter } from 'vue-router'
import { ref } from 'vue'
import { reactive } from 'vue'
import { Icon } from '@iconify/vue'
import ImagePicker from '@/onenetwork/components/image_picker/ImagePicker.vue'
import { uuid } from 'vue3-uuid'
import FileMan from '@/onenetwork/components/fileman/FileMan.vue'

const router = useRouter()

const initialValues = reactive({
  title: '',
  content: '',
  excerpt: '',
  slug: '',
  status: 'draft',
  categories: [],
  tags: [],
  seo: {
    title: '',
    description: '',
    keywords: [],
    image: '',
  },
})

const imagePicker = ref({
  uuid: '',
  type: 'image',
})

const resolver = ({ values }: any) => {
  const errors = {}

  // if (!values.username) {
  //   errors.username = [{ message: 'Username is required.' }];
  // }

  return {
    values, // (Optional) Used to pass current form values to submit event.
    errors,
  }
}

const onFormSubmit = ({ valid }: any) => {
  if (valid) {
    alert('xxx')
  }
}

const route = useRoute()

const handleCustomClick = () => {
  alert('Custom button clicked!')
}

// optional: use this if you're registering a toolbar module manually
// const quillModules = {
//   toolbar: '#quill-toolbar',
// }

const handleOpenFileman = (uuid: string) => {
  imagePicker.value = {
    uuid,
    type: 'image',
  }
}

const handleChooseFile = (file: any) => {
  imagePicker.value = {
    uuid: '',
    type: 'image',
  }

  const targetPreview = document.getElementById(`ipk-preview-${file.picker.uuid}`)
  if (targetPreview) {
    targetPreview.src = file.file.url
  }
  const targetCaption = document.getElementById(`ipk-caption-${file.picker.uuid}`)
  if (targetCaption) {
    targetCaption.textContent = file.file.path
  }
}

const handleOpenUXBuilder = () => {
  router.push({
    name: 'uxbuilder',
  })
}
</script>

<template>
  <dashboard-layout
    currentRoute="posts.posts"
    :page-title="route.name == 'post-create' ? `Thêm bài viết` : `Chỉnh sửa bài viết`"
  >
    <Form
      v-slot="$form"
      :initialValues
      :resolver
      @submit="onFormSubmit"
      class="flex flex-col gap-4 w-full cs-form"
    >
      <!--      <div class="flex flex-col gap-1">-->
      <!--        <InputText name="title" type="text" placeholder="Username" fluid />-->
      <!--        <Message v-if="$form.title?.invalid" severity="error" size="small" variant="simple">{{ $form.title.error?.message }}</Message>-->
      <!--      </div>-->
      <!--      <Button type="submit" severity="secondary">Lưu</Button>-->

      <!--      {{ initialValues }}-->
      <Card>
        <template #content>
          <div class="flex">
            <div class="flex flex-col w-[calc(100%-450px)] sm:px-[16px]">
              <div class="flex">
                <!--                <h4 class="font-bold">Soạn thảo bài viết</h4>-->
              </div>
              <div class="">
                <Fieldset legend="Nội dung cơ bản" :toggleable="true">
                  <div class="flex flex-col gap-1 mb-3">
                    <FloatLabel variant="in">
                      <InputText id="in_label" name="title" autocomplete="off" fluid />
                      <label for="in_label">Tiêu đề bài viết</label>
                    </FloatLabel>
                    <Message
                      v-if="$form.title?.invalid"
                      severity="error"
                      size="small"
                      variant="simple"
                      >{{ $form.title.error?.message }}</Message
                    >
                  </div>
                  <div class="flex flex-col gap-1 mb-3">
                    <FloatLabel variant="in">
                      <InputText id="in_label" name="title" autocomplete="off" fluid />
                      <label for="in_label">Slug</label>
                    </FloatLabel>
                    <Message
                      v-if="$form.title?.invalid"
                      severity="error"
                      size="small"
                      variant="simple"
                      >{{ $form.title.error?.message }}</Message
                    >
                  </div>
                  <div class="flex flex-col gap-1 mb-3 mt-[32px]">
                    <label>Nội dung bài viết</label>
                    <template v-if="false">
                      <FloatLabel variant="in">
                        <Editor name="content" editorStyle="min-height: 320px">
                          <template v-slot:toolbar>
                            <div id="quill-toolbar">
                              <!-- full default toolbar -->
                              <span class="ql-formats">
                                <select class="ql-font"></select>
                                <select class="ql-size"></select>
                              </span>
                              <span class="ql-formats">
                                <button class="ql-bold"></button>
                                <button class="ql-italic"></button>
                                <button class="ql-underline"></button>
                                <button class="ql-strike"></button>
                              </span>
                              <span class="ql-formats">
                                <select class="ql-color"></select>
                                <select class="ql-background"></select>
                              </span>
                              <span class="ql-formats">
                                <button class="ql-script" value="sub"></button>
                                <button class="ql-script" value="super"></button>
                              </span>
                              <span class="ql-formats">
                                <button class="ql-header" value="1"></button>
                                <button class="ql-header" value="2"></button>
                                <button class="ql-blockquote"></button>
                                <button class="ql-code-block"></button>
                              </span>
                              <span class="ql-formats">
                                <button class="ql-list" value="ordered"></button>
                                <button class="ql-list" value="bullet"></button>
                                <button class="ql-indent" value="-1"></button>
                                <button class="ql-indent" value="+1"></button>
                              </span>
                              <span class="ql-formats">
                                <button class="ql-direction" value="rtl"></button>
                                <select class="ql-align"></select>
                              </span>
                              <!--                              <span class="ql-formats">-->
                              <!--                                <button class="ql-link"></button>-->
                              <!--                                <button class="ql-image"></button>-->
                              <!--                                <button class="ql-video"></button>-->
                              <!--                                <button class="ql-formula"></button>-->
                              <!--                              </span>-->
                              <span class="ql-formats">
                                <button class="ql-clean"></button>
                              </span>
                              <!-- 🔸 Custom button -->

                              <span class="ql-formats">
                                <button
                                  @click="handleCustomClick"
                                  id="custom-button"
                                  v-tooltip.bottom="`Chèn ảnh/video`"
                                >
                                  <Icon icon="fa6-solid:photo-film" width="24px" height="24px" />
                                </button>
                                <button
                                  @click="handleCustomClick"
                                  id="custom-button"
                                  v-tooltip.bottom="`Chèn shortcode`"
                                >
                                  <Icon icon="lucide:code-xml" width="24px" height="24px" />
                                </button>
                              </span>
                            </div>
                          </template>
                        </Editor>
                      </FloatLabel>
                    </template>
                    <template v-else>
                      <div class="flex flex-start gap-1 mb-3">
                        <button
                          class="btn btn-secondary"
                          type="button"
                          @click="handleOpenUXBuilder"
                        >
                          Chỉnh sửa bằng NicePress UXbuilder
                        </button>
                      </div>
                    </template>
                    <Message
                      v-if="$form.title?.invalid"
                      severity="error"
                      size="small"
                      variant="simple"
                      >{{ $form.title.error?.message }}</Message
                    >
                  </div>
                </Fieldset>
              </div>
              <div class="">
                <Fieldset legend="SEO" :toggleable="true">
                  <div class="flex flex-col gap-1 mb-3">
                    <FloatLabel variant="in">
                      <InputText id="in_label" name="title" autocomplete="off" fluid />
                      <label for="in_label">Meta title</label>
                    </FloatLabel>
                    <Message
                      v-if="$form.title?.invalid"
                      severity="error"
                      size="small"
                      variant="simple"
                      >{{ $form.title.error?.message }}</Message
                    >
                  </div>
                  <div class="flex flex-col gap-1 mb-3">
                    <FloatLabel variant="in">
                      <InputText id="in_label" name="title" autocomplete="off" fluid />
                      <label for="in_label">Meta description</label>
                    </FloatLabel>
                    <Message
                      v-if="$form.title?.invalid"
                      severity="error"
                      size="small"
                      variant="simple"
                      >{{ $form.title.error?.message }}</Message
                    >
                  </div>
                  <div class="flex flex-col gap-1 mb-3">
                    <label>og:image</label>
                    <image-picker
                      width="300px"
                      height="200px"
                      :uuid="uuid.v4()"
                      @action:open-fileman="handleOpenFileman"
                    />
                  </div>
                </Fieldset>
              </div>
            </div>
            <div
              class="flex flex-col w-[450px] sm:border-solid sm:border-l-1 sm:border-gray-200 sm:px-[16px]"
            >
              <div class="flex flex-col gap-1 mb-3">
                <label>Ảnh đại diện</label>
                <image-picker
                  width="100%"
                  height="200px"
                  :uuid="uuid.v4()"
                  @action:open-fileman="handleOpenFileman"
                />
              </div>
              <div class="flex flex-col gap-1 mb-3">
                <IftaLabel>
                  <DatePicker dateFormat="dd/mm/yy" fluid />
                  <label for="in_label">Ngày xuất bản</label>
                </IftaLabel>
                <Message
                  v-if="$form.title?.invalid"
                  severity="error"
                  size="small"
                  variant="simple"
                  >{{ $form.title.error?.message }}</Message
                >
              </div>
              <div class="flex flex-col gap-1 mb-3">
                <IftaLabel variant="in">
                  <InputText id="in_label" name="title" autocomplete="off" fluid />
                  <label for="in_label">Trạng thái</label>
                </IftaLabel>
                <Message
                  v-if="$form.title?.invalid"
                  severity="error"
                  size="small"
                  variant="simple"
                  >{{ $form.title.error?.message }}</Message
                >
              </div>
              <div class="flex flex-col gap-1 mb-3">
                <IftaLabel variant="in">
                  <InputText id="in_label" name="title" autocomplete="off" fluid />
                  <label for="in_label">Giao diện trang</label>
                </IftaLabel>
                <Message
                  v-if="$form.title?.invalid"
                  severity="error"
                  size="small"
                  variant="simple"
                  >{{ $form.title.error?.message }}</Message
                >
              </div>
              <div class="flex flex-col gap-1 mb-3">
                <IftaLabel variant="in">
                  <InputText id="in_label" name="title" autocomplete="off" fluid />
                  <label for="in_label">Danh mục</label>
                </IftaLabel>
                <Message
                  v-if="$form.title?.invalid"
                  severity="error"
                  size="small"
                  variant="simple"
                  >{{ $form.title.error?.message }}</Message
                >
              </div>
              <div class="flex flex-col gap-1 mb-3">
                <IftaLabel variant="in">
                  <InputText id="in_label" name="title" autocomplete="off" fluid />
                  <label for="in_label">Thẻ</label>
                </IftaLabel>
                <Message
                  v-if="$form.title?.invalid"
                  severity="error"
                  size="small"
                  variant="simple"
                  >{{ $form.title.error?.message }}</Message
                >
              </div>
              <div class="flex mb-3 gap-2 mt-5">
                <button type="submit" class="w-full btn btn-primary !p-[16px]">Xuất bản</button>
                <button type="submit" class="w-full btn btn-secondary !p-[16px]">Lưu nháp</button>
              </div>
            </div>
          </div>
        </template>
      </Card>
    </Form>
  </dashboard-layout>

  <file-man :picker="imagePicker" @close="imagePicker.uuid = ''" @choose-file="handleChooseFile" />
</template>

<style scoped></style>
